<template>

    <b-row>

        <b-col>

            <b-card>

                <h3>Provider Sync Status: <span :class=" syncClass ">{{ syncStatus }}</span></h3>

                <b-row>

                    <b-col sm="4">

                        <h3>Current CareExchange Profile Data</h3>
                        <div class="mb-0 small d-flex justify-content-between"><span class="font-bold mr-1">UPD ID</span>{{ caregiver.upd_id }}</div>
                        <div class="mb-0 small d-flex justify-content-between"><span class="font-bold mr-1">FirstName</span>{{ caregiver.firstname }}</div>
                        <div class="mb-0 small d-flex justify-content-between"><span class="font-bold mr-1">LastName</span>{{ caregiver.lastname }}</div>
                        <div class="mb-0 small d-flex justify-content-between"><span class="font-bold mr-1">AddressLine1</span>{{ caregiver.home_address ? caregiver.home_address.address1 : null }}</div>
                        <div class="mb-0 small d-flex justify-content-between"><span class="font-bold mr-1">AddressLine2</span>{{ caregiver.home_address ? caregiver.home_address.address2 : null }}</div>
                        <div class="mb-0 small d-flex justify-content-between"><span class="font-bold mr-1">City</span>{{ caregiver.home_address ? caregiver.home_address.city : null }}</div>
                        <div class="mb-0 small d-flex justify-content-between"><span class="font-bold mr-1">State</span>{{ caregiver.home_address ? caregiver.home_address.state : null }}</div>
                        <div class="mb-0 small d-flex justify-content-between"><span class="font-bold mr-1">Zip</span>{{ caregiver.home_address ? caregiver.home_address.zip : null }}</div>
                        <div class="mb-0 small d-flex justify-content-between"><span class="font-bold mr-1">CountryCode</span>{{ caregiver.home_address ? caregiver.home_address.country : null }}</div>
                        <div class="mb-0 small d-flex justify-content-between"><span class="font-bold mr-1">Phone</span>{{ this.caregiver.contact_number ? this.caregiver.contact_number.national_number : null }}</div>
                        <div class="mb-0 small d-flex justify-content-between"><span class="font-bold mr-1">Email</span>{{ formatEmail( caregiver.email ) }}</div>
                    </b-col>
                    <b-col sm="8">

                        <h3>Fuzzy Match details & results</h3>
                        <upd-fuzzy-match :providerdata=" adaptedData " v-model=" matchResults " :selectProvider=" selectProvider " :selectedProvider=" selectedProvider "></upd-fuzzy-match>
                        <b-row>

                            <b-col class="d-flex justify-content-end">

                                <span id="tooltip-target-update-careexchange">

                                    <b-button variant="success" @click=" updateCareExchangeProvider " :disabled=" isDisabled " class="mr-2 d-flex align-items-center justify-content-between">
                                        <i :class=" iconClasses "></i>
                                        Update Provider in CareExchange
                                    </b-button>
                                </span>
                                <b-tooltip target="tooltip-target-update-careexchange" triggers="hover">
                                    {{ tooltipTitle }}
                                </b-tooltip>

                                <upd-update-provider :providerdata=" updateProviderAdaptedData " :isDisabled=" isDisabled " class="mr-2"></upd-update-provider>
                                <upd-create-provider :providerdata=" createProviderAdaptedData " :isDisabled=" disableButton "></upd-create-provider>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>

    import UpdApiAdapter from '../../mixins/UpdApiAdapter';
    import UsesRole from '../../mixins/UsesRole';
    import LoadingToggles from '../../mixins/LoadingToggles';
    import FormatsListData from "../../mixins/FormatsListData";

    export default {

        mixins : [ UpdApiAdapter, UsesRole, LoadingToggles, FormatsListData ],
        props: {

            caregiver: Object
        },
        data(){

            return {

                upd_api_type : 'profile',
                baseIcon     : 'fa-download'
            }
        },
        computed: {

            tooltipTitle(){

                return ( this.isDisabled ? 'A matched provider must be selected first.' : 'Update this provider in CareExchange with the data currently in the UPD.' );
            },
            disableButton(){

                return !this.matchResults || this.perfectMatches.length > 0;
            },
            isDisabled(){

                return !this.matchResults || !this.selectedProvider;
            },
            syncStatus(){

                let status = '';
                if( !this.caregiver.upd_id ) status += 'No UPD ID in CareExchange.';
                else status += 'UPD ID established in CareExchange.';

                if( this.matchResults && this.matchResults.length == 0 ) status += ' No matches found in UPD.';

                if( this.matchResults && this.perfectMatches.length < 1 && this.matchResults.length > 1 ) status += ' Multiple partial matches found in UPD.';
                if( this.matchResults && this.perfectMatches.length == 1 && this.caregiver.upd_id ) status += ' Provider matched in UPD';
                if( this.matchResults && this.perfectMatches.length == 1 && !this.caregiver.upd_id ) status += ' UPD perfect match found';

                return status;
            },
            syncClass(){

                const base = [ 'small' ];

                if( !this.caregiver.upd_id ) base.push( 'text-danger' );
                else if( this.matchResults && this.matchResults.length == 0 ) base.push( 'text-warning' );
                else if( this.matchResults && this.perfectMatches.length < 1 && this.matchResults.length > 1 ) base.push( 'text-warning' );
                else base.push( 'text-success' );

                return base.join( ' ' );
            }
        },
        methods: {

            updateCareExchangeProvider(){

                if( !this.selectedProvider ) return;

                this.isLoading = true;

                let form = new Form({

                    'UpdId'          : this.selectedProvider.UpdId,
                    'FirstName'      : this.selectedProvider.IndependentProvider.FirstName,
                    'LastName'       : this.selectedProvider.IndependentProvider.LastName,
                    'AddressLine1'   : this.selectedProvider.IndependentProvider.AddressLine1,
                    'AddressLine2'   : this.selectedProvider.IndependentProvider.AddressLine2,
                    'City'           : this.selectedProvider.IndependentProvider.City,
                    'State'          : this.selectedProvider.IndependentProvider.State,
                    'Zip'            : this.selectedProvider.IndependentProvider.Zip,
                    'CountryCode'    : this.selectedProvider.IndependentProvider.CountryCode,
                    'Phone'          : this.selectedProvider.IndependentProvider.Phone,
                    'PhoneExt'       : this.selectedProvider.IndependentProvider.PhoneExt,
                    'Email'          : this.selectedProvider.IndependentProvider.Email,
                });

                form.patch( `/business/caregivers/${this.caregiver.id}/updUpdate` )
                    .then( res => console.log( res ) )
                    .finally( () => this.isLoading = false );
            }
        }
    }
</script>

<style>

</style>